// AUTO-GENERATED. Do not edit. To run => npm run handle-colors
export const Color = {
  Surface: {
    Surface1: 'surface-surface-1',
    Surface2: 'surface-surface-2',
    Surface3: 'surface-surface-3',
    Surface4: 'surface-surface-4',
    SmokeGray: 'surface-smoke-gray',
    SmokeGrayEm: 'surface-smoke-gray-em',
    WhiteSmoke0: 'surface-white-smoke-0',
    WhiteSmoke1: 'surface-white-smoke-1',
    WhiteSmoke2: 'surface-white-smoke-2',
    WhiteSmoke3: 'surface-white-smoke-3',
    WhiteSmoke4: 'surface-white-smoke-4',
    White: 'surface-white',
    Black: 'surface-black',
    InverseWhiteNeutral: 'surface-inverse-white-neutral',
    InverseBlackNeutral: 'surface-inverse-black-neutral',
    DisabledHighEm: 'surface-disabled-high-em',
    DisabledMedEm: 'surface-disabled-med-em',
    DisabledLowEm: 'surface-disabled-low-em',
    DisabledBaseEm: 'surface-disabled-base-em',
    PrimaryHighEm: 'surface-primary-high-em',
    PrimaryMedEm: 'surface-primary-med-em',
    PrimaryLowEm: 'surface-primary-low-em',
    PrimaryBaseEm: 'surface-primary-base-em',
    PrimaryLowEmAlpha: 'surface-primary-low-em-alpha',
    PrimaryBaseEmAlpha: 'surface-primary-base-em-alpha',
    SecondaryHighEm: 'surface-secondary-high-em',
    SecondaryMedEm: 'surface-secondary-med-em',
    SecondaryLowEm: 'surface-secondary-low-em',
    SecondaryBaseEm: 'surface-secondary-base-em',
    SecondaryLowEmAlpha: 'surface-secondary-low-em-alpha',
    SecondaryBaseEmAlpha: 'surface-secondary-base-em-alpha',
    TertiaryHighEm: 'surface-tertiary-high-em',
    TertiaryMedEm: 'surface-tertiary-med-em',
    TertiaryLowEm: 'surface-tertiary-low-em',
    TertiaryLowEmAlpha: 'surface-tertiary-low-em-alpha',
    TertiaryBaseEm: 'surface-tertiary-base-em',
    TertiaryBaseEmAlpha: 'surface-tertiary-base-em-alpha',
    SuccessHighEm: 'surface-success-high-em',
    SuccessMedEm: 'surface-success-med-em',
    SuccessLowEm: 'surface-success-low-em',
    SuccessBaseEm: 'surface-success-base-em',
    SuccessLowEmAlpha: 'surface-success-low-em-alpha',
    SuccessBaseEmAlpha: 'surface-success-base-em-alpha',
    InfoHighEm: 'surface-info-high-em',
    InfoMedEm: 'surface-info-med-em',
    InfoLowEm: 'surface-info-low-em',
    InfoBaseEm: 'surface-info-base-em',
    InfoLowEmAlpha: 'surface-info-low-em-alpha',
    InfoBaseEmAlpha: 'surface-info-base-em-alpha',
    InfoPMedEm: 'surface-info-p-med-em',
    InfoPHighEm: 'surface-info-p-high-em',
    InfoPBaseEm: 'surface-info-p-base-em',
    InfoPLowEmAlpha: 'surface-info-p-low-em-alpha',
    InfoPBaseEmAlpha: 'surface-info-p-base-em-alpha',
    WarningHighEm: 'surface-warning-high-em',
    WarningMedEm: 'surface-warning-med-em',
    WarningLowEm: 'surface-warning-low-em',
    WarningBaseEm: 'surface-warning-base-em',
    WarningLowEmAlpha: 'surface-warning-low-em-alpha',
    WarningBaseEmAlpha: 'surface-warning-base-em-alpha',
    OrangeHighEm: 'surface-orange-high-em',
    OrangeBaseEmAlpha: 'surface-orange-base-em-alpha',
    DangerHighEm: 'surface-danger-high-em',
    DangerMedEm: 'surface-danger-med-em',
    DangerLowEm: 'surface-danger-low-em',
    DangerBaseEm: 'surface-danger-base-em',
    DangerLowEmAlpha: 'surface-danger-low-em-alpha',
    DangerBaseEmAlpha: 'surface-danger-base-em-alpha',
    NeutralHighEm: 'surface-neutral-high-em',
    NeutralMedEm: 'surface-neutral-med-em',
  },
  Text: {
    PrimaryDarkEm: 'text-primary-dark-em',
    HighEm: 'text-high-em',
    MedEm: 'text-med-em',
    LowEm: 'text-low-em',
    BaseEm: 'text-base-em',
    White: 'text-white',
    Black: 'text-black',
    InverseWhiteNeutral: 'text-inverse-white-neutral',
    InverseBlackNeutral: 'text-inverse-black-neutral',
    PrimaryHighEm: 'text-primary-high-em',
    PrimaryMedEm: 'text-primary-med-em',
    PrimaryLowEm: 'text-primary-low-em',
    PrimaryBaseEm: 'text-primary-base-em',
    SecondaryHighEm: 'text-secondary-high-em',
    SecondaryMedEm: 'text-secondary-med-em',
    SecondaryLowEm: 'text-secondary-low-em',
    SecondaryBaseEm: 'text-secondary-base-em',
    SuccessHighEm: 'text-success-high-em',
    SuccessMedEm: 'text-success-med-em',
    SuccessLowEm: 'text-success-low-em',
    SuccessBaseEm: 'text-success-base-em',
    InfoHighEm: 'text-info-high-em',
    InfoMedEm: 'text-info-med-em',
    InfoLowEm: 'text-info-low-em',
    InfoBaseEm: 'text-info-base-em',
    WarningHighEm: 'text-warning-high-em',
    WarningMedEm: 'text-warning-med-em',
    WarningLowEm: 'text-warning-low-em',
    WarningBaseEm: 'text-warning-base-em',
    DangerHighEm: 'text-danger-high-em',
    DangerMedEm: 'text-danger-med-em',
    DangerLowEm: 'text-danger-low-em',
    DangerBaseEm: 'text-danger-base-em',
    PurpleHighEm: 'text-purple-high-em',
    PurpleMedEm: 'text-purple-med-em',
    PurpleLowEm: 'text-purple-low-em',
    PurpleBaseEm: 'text-purple-base-em',
    OrangeHighEm: 'text-orange-high-em',
    currentColor: 'currentColor',
  },
  Outline: {
    HighEm: 'outline-high-em',
    MedEm: 'outline-med-em',
    LowEm: 'outline-low-em',
    BaseEm: 'outline-base-em',
    White: 'outline-white',
    Black: 'outline-black',
    InverseWhiteNeutral: 'outline-inverse-white-neutral',
    InverseBlackNeutral: 'outline-inverse-black-neutral',
    PrimaryHighEm: 'outline-primary-high-em',
    PrimaryMedEm: 'outline-primary-med-em',
    PrimaryLowEm: 'outline-primary-low-em',
    PrimaryBaseEm: 'outline-primary-base-em',
    PrimaryAlpha: 'outline-primary-alpha',
    SecondaryHighEm: 'outline-secondary-high-em',
    SecondaryMedEm: 'outline-secondary-med-em',
    SecondaryLowEm: 'outline-secondary-low-em',
    SecondaryBaseEm: 'outline-secondary-base-em',
    SecondaryAlpha: 'outline-secondary-alpha',
    SuccessHighEm: 'outline-success-high-em',
    SuccessMedEm: 'outline-success-med-em',
    SuccessLowEm: 'outline-success-low-em',
    SuccessBaseEm: 'outline-success-base-em',
    SuccessAlpha: 'outline-success-alpha',
    InfoHighEm: 'outline-info-high-em',
    InfoMedEm: 'outline-info-med-em',
    InfoLowEm: 'outline-info-low-em',
    InfoBaseEm: 'outline-info-base-em',
    InfoAlpha: 'outline-info-alpha',
    WarningHighEm: 'outline-warning-high-em',
    WarningMedEm: 'outline-warning-med-em',
    WarningLowEm: 'outline-warning-low-em',
    WarningBaseEm: 'outline-warning-base-em',
    WarningAlpha: 'outline-warning-alpha',
    DangerHighEm: 'outline-danger-high-em',
    DangerMedEm: 'outline-danger-med-em',
    DangerLowEm: 'outline-danger-low-em',
    DangerBaseEm: 'outline-danger-base-em',
    DangerAlpha: 'outline-danger-alpha',
    PrimarySpecialTop: 'outline-primary-special-top',
    PrimarySpecialBottom: 'outline-primary-special-bottom',
    SecondarySpecialTop: 'outline-secondary-special-top',
    SecondarySpecialBottom: 'outline-secondary-special-bottom',
    PurpleHighEm: 'outline-purple-high-em',
    PurpleMedEm: 'outline-purple-med-em',
    PurpleLowEm: 'outline-purple-low-em',
    PurpleBaseEm: 'outline-purple-base-em',
    PurpleAlpha: 'outline-purple-alpha',
    None: 'outline-none',
  },
  NeutralInverseWhite: {
    Alpha3: 'neutral-inverse-white-alpha-3',
    Alpha6: 'neutral-inverse-white-alpha-6',
    Alpha9: 'neutral-inverse-white-alpha-9',
    Alpha12: 'neutral-inverse-white-alpha-12',
    Alpha24: 'neutral-inverse-white-alpha-24',
    Alpha32: 'neutral-inverse-white-alpha-32',
    Alpha48: 'neutral-inverse-white-alpha-48',
    Alpha56: 'neutral-inverse-white-alpha-56',
    Alpha64: 'neutral-inverse-white-alpha-64',
    Alpha72: 'neutral-inverse-white-alpha-72',
    Alpha88: 'neutral-inverse-white-alpha-88',
  },
  NeutralInverseBlack: {
    Alpha3: 'neutral-inverse-black-alpha-3',
    Alpha6: 'neutral-inverse-black-alpha-6',
    Alpha9: 'neutral-inverse-black-alpha-9',
    Alpha12: 'neutral-inverse-black-alpha-12',
    Alpha24: 'neutral-inverse-black-alpha-24',
    Alpha32: 'neutral-inverse-black-alpha-32',
    Alpha48: 'neutral-inverse-black-alpha-48',
    Alpha56: 'neutral-inverse-black-alpha-56',
    Alpha64: 'neutral-inverse-black-alpha-64',
    Alpha72: 'neutral-inverse-black-alpha-72',
    Alpha88: 'neutral-inverse-black-alpha-88',
  },
} as const

type Values<T> = T[keyof T]
export type SurfaceColorType = Values<(typeof Color)['Surface']>
export type TextColorType = Values<(typeof Color)['Text']>
export type OutlineColorType = Values<(typeof Color)['Outline']>
export type NeutralInverseWhiteColorType = Values<(typeof Color)['NeutralInverseWhite']>
export type NeutralInverseBlackColorType = Values<(typeof Color)['NeutralInverseBlack']>
export type AnyColorType =
  | SurfaceColorType
  | TextColorType
  | OutlineColorType
  | NeutralInverseWhiteColorType
  | NeutralInverseBlackColorType
